import { useState, useCallback } from 'react';
import AddIcon from '@mui/icons-material/Add';
import Button from '../../../core-components/theme/components/Button/Button';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import AddLogbookTemplateModal from './AddLogbookTemplateModal';
import { useQueryClient } from '@tanstack/react-query';
import { fetchLogbookOptions } from '../api/logbookApi';
import { createPrefetchHandler } from '../../../utilities/prefetchHandler';

export default function AddLogbookTemplateButtonAndModal() {
    const [openEditLogbookTemplateBox, setOpenEditLogbookTemplateBox] = useState(false);
    const queryClient = useQueryClient()
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const prefetchLogbookOptions = createPrefetchHandler(queryClient, {
        queryKey: ['logbookOptions'],
        queryFn: fetchLogbookOptions,
        staleTime: 60000,
    });

    const handleOpen = useCallback(() => {
        setOpenEditLogbookTemplateBox(true);
    }, []);

    const handleClose = useCallback(() => {
        setOpenEditLogbookTemplateBox(false);
    }, []);

    return (
        <>
            <Button
                onClick={handleOpen}
                onMouseEnter={prefetchLogbookOptions}
                title="Add Logbook Template"
                variant="contained"
                aria-label="Add a new logbook template"
            >
                <AddIcon />
                {!isMobile && 'Add Template'}
            </Button>

            {openEditLogbookTemplateBox && (
                <AddLogbookTemplateModal open={openEditLogbookTemplateBox} onClose={handleClose} />
            )}
        </>
    );
}
